export default {
  priv: 'pr_layouts',
  overviewTitle: 'Templates',
  detailTitle: 'Template',
  deleteTitle: 'deze template',
  url: '/manage/templates',
  apiUrl: '/doctemplates/',
  sortBy: ['name'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'templates',
  quickFilter: {
    text: 'Zoek op naam',
    value: 'name',
    type: 'str'
  },
  tableFields: [
    {
      text: 'Naam',
      value: 'name',
      link: '/manage/templates/{id}',
      width: '15%'
    },
    {
      text: 'Bestandsnaam',
      value: 'file.name',
      width: '15%'
    },
    {
      text: 'Grootte',
      value: 'file.size',
      width: '15%',
      filter: 'prettyBytes'
    },
    {
      text: 'Aangemaakt op',
      value: 'file.timestamp',
      width: '15%',
      align: 'center',
      filter: 'timestamp'
    },
    {
      text: 'Bestand',
      value: 'file',
      width: '10%',
      type: 'file',
      align: 'center',
      sortable: false
    }
  ]
};
